import { useState } from "react";
import { Select } from "antd";
import {
  INVITATION_GOOGLE_FONTS,
  loadInvitationGoogleFonts,
} from "../../utils/invitationGoogleFonts";

export default function FontPicker({ value, onChange, disabled, style }) {
  const [loading, setLoading] = useState(false);

  const handleChange = (font) => {
    setLoading(true);
    loadInvitationGoogleFonts([font]).finally(() => {
      setLoading(false);
      onChange?.(font);
    });
  };

  return (
    <Select
      showSearch
      placeholder="Font"
      optionFilterProp="label"
      value={value}
      onChange={handleChange}
      disabled={disabled}
      loading={loading}
      style={{ minWidth: 200, ...style }}
      options={INVITATION_GOOGLE_FONTS.map((f) => ({
        value: f.value,
        label: f.label,
      }))}
    />
  );
}
